var render = function render(){var _vm=this,_c=_vm._self._c;return _c('h5',{staticClass:"mt-8 mb-3 text-h5 font-weight-medium primary-font-color--text"},[_vm._v(" "+_vm._s(_vm.title)+" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }